<template>
	<div class="groupsManage">
		<div class="filters">
			<el-form :inline="true">
				<el-form-item>
					<el-input v-model="name" clearable :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_groupsName')"></el-input>
				</el-form-item>
				<el-button type="primary" @click="selectAll">{{$t('lang.btn_search')}}</el-button>
			</el-form>
		</div>
		<el-card>
			<el-button type="primary" slot="header" @click="addGroups()">{{$t('lang.lab_addGroups')}}</el-button>
			<el-table :data="tableData" style="width: 100%" :row-class-name="tableRowClassName">
				<!-- 序号 -->
				<el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
				</el-table-column>
				<!-- 集团名称 -->
				<el-table-column prop="name" :label="$t('lang.lab_groupsName')" width="180">
				</el-table-column>
				<el-table-column prop="imageUri" :label="$t('lang.lab_photograph')" width="180">
					<template slot-scope="scope">
						<el-image style="width: 80px; cursor:pointer;" :src="scope.row.imageUri" fit="cover" :preview-src-list="imageUriList"></el-image>
					</template>
				</el-table-column>
				<el-table-column prop="indexPageUrl" label="集团LOGO" width="180">
					<template slot-scope="scope">
						<el-image v-if="scope.row.indexPageUrl" style="width: 80px; cursor:pointer;" :src="scope.row.indexPageUrl" fit="cover" :preview-src-list="imageUriList1"></el-image>
						<el-image v-else style="width: 80px; cursor:pointer;" src="https://yunnanyihe.oss-cn-heyuan.aliyuncs.com/2025/02/26/4e4a60fb-7e19-41d7-b09c-744fbb708d80.png" fit="cover" :preview-src-list="imageUriList1"></el-image>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" :label="$t('lang.lab_ctDoorDeviceSon')">
					<template slot-scope="scope" v-if="scope&&scope.row.createTime">{{scope.row.createTime | formatDate}}</template>
				</el-table-column>
				<el-table-column :label="$t('lang.lab_operation')" fixed="right" :width="require('@/config/enum').opr_width3">
					<template slot-scope="scope">
						<el-button class="tableButton" @click="openDept(scope.row.id)">{{$t('lang.lab_isDeptName')}}</el-button>
						<el-button class="tableButton" @click="openGardenDialog(scope.row)">{{$t('lang.lab_configGroups')}}</el-button>
						<el-button class="tableButton" @click="editGroups(scope.row)">{{$t('lang.btn_modify')}}</el-button>
						<el-button class="orange" @click="delGroups(scope.row)">{{$t('lang.btn_delete')}}</el-button>
						
					</template>
				</el-table-column>
			</el-table>
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
			    :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
			    :page-count="pageCount" />
		</el-card>

		<el-dialog :title="addOrEdit==0?$t('lang.lab_addGroups'):$t('lang.lab_editGroups')" :visible.sync="groupsVisible"
		 :close-on-click-modal='false' width="50%">
			<el-form :rules="rules" :model="groupForm" ref="groupForm" style="width: 60%;" :label-width="require('@/config/enum').c_ws13"
			 :label-suffix="require('@/config/enum').c_colon">
				<el-form-item :label="$t('lang.lab_addGroups')" prop="name">
					<el-input v-model="groupForm.name" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="集团图片" prop="avatarUri" ref="avatarUri">
					<upload-file ref="uploading" :accept='accept' upTypes='1' :fileList='fileList' :clears='clears' @outputFile="getFile"
					 @removeFile='removeFile'></upload-file>
				</el-form-item>
				<el-form-item label="集团LOGO" prop="indexPageUrl" ref="indexPageUrl">
					<upload-file ref="uploading" :accept='accept' upTypes='1' :fileList='fileList1' :clears='clears' @outputFile="getFile1"
					 @removeFile='removeFile1'></upload-file>
					 <p class="tips">特别注意：为保证LOGO展示效果，请上传宽高比为3:1的png格式图片</p>
					 <p class="tips">提示：如果不传集团LOGO图片，集团LOGO默认为众乐家LOGO</p>
				</el-form-item>
				<el-form-item label="修改原始业主信息是否需要审批" prop="editPreInfoIsUseApprove">
					<el-radio-group v-model="groupForm.editPreInfoIsUseApprove">
						<el-radio label="1">是</el-radio>
						<el-radio label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item></el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="groupsVisible = false">{{$t('lang.btn_cancel')}}</el-button>
				<el-button type="primary" @click="save">{{$t('lang.btn_confirm')}}</el-button>
			</div>
		</el-dialog>

		<el-dialog :title="$t('lang.lab_configGarden')" :visible.sync="gardenVisible" :close-on-click-modal='false' width="50%">
			<el-form :model="gardenForm" style="width: 30%;" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
				<el-form-item style="width: 280%;">
					<el-checkbox-group v-model="gardenForm.gardenArr">
						<el-checkbox v-for="(item,index) in gardenList" :disabled="item.isDisable" :label="item.id" :key="index">{{item.name}}</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="gardenVisible = false">{{$t('lang.btn_cancel')}}</el-button>
				<el-button type="primary" @click="saveGarden">{{$t('lang.btn_confirm')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import UploadFile from '../../../components/upload_file.vue'
	export default {
		name: '/manage/main.groupsManage',
		filters: {
			formatDate(time) {
				var x = new Date(time)
				var z = {
					y: x.getFullYear(),
					M: x.getMonth() + 1,
					d: x.getDate(),
					h: x.getHours(),
					m: x.getMinutes(),
					s: x.getSeconds(),
				}
				if (z.M < 10) {
					z.M = '0' + z.M
				}
				if (z.d < 10) {
					z.d = '0' + z.d
				}
				if (z.h < 10) {
					z.h = '0' + z.h
				}
				if (z.m < 10) {
					z.m = '0' + z.m
				}
				return z.y + '-' + z.M + '-' + z.d
			}
		},
		data() {
			return {
				accept: '.jpg, .jpeg, .png',
				fileList: [], // 图片上传
				fileList1: [], // 图片上传
				clears: false, // 清空按钮
				// uploadCss:{},

				pageNo: 1,
				pageSize: 10,
				pageCount: 0, // 总页数
				groupId: '',
				name: '',
				groupForm: {
					name: '',
					avatarUri: '',
					indexPageUrl: '',
					editPreInfoIsUseApprove: '0',
				},
				tableData: [],
				imageUriList: [],
				imageUriList1: [],
				addOrEdit: 0,

				groupsVisible: false,
				gardenVisible: false,
				gardenList: [],
				gardenForm: {
					gardenArr: [],
				},

				rules: {
					name: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') +
							this.$i18n.t('lang.lab_Adminnickname'),
						trigger: 'blur'
					}],
					avatarUri: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Upload') +
							this.$i18n.t('lang.lab_uploadPhotograph'),
						trigger: 'change'
					}],
				},
			}
		},
		components: {
			'upload-file': UploadFile
		},
		/* watch:{
			groupForm:{
				handler(newVal, oldVal) {
					console.log(this.groupForm.avatarUri);
					if(this.groupForm.avatarUri!=''){
						console.log(document.getElementById("qqq"));
						 this.uploadCss={
							display: 'none!important'
						} 
						
					}
				},
				deep: true,
				immediate: true
			}
		}, */
		mounted() {
			this.selectAll()
		},
		methods: {
			// 获取组件值
			getFile(e) {
				this.groupForm.avatarUri = e
				this.$refs.avatarUri.clearValidate()
			},
			getFile1(e) {
				this.groupForm.indexPageUrl = e
				this.$refs.indexPageUrl.clearValidate()
			},
			openDept(id) {
				this.$router.push({
					path: '/manage/main.deptGroup',
					query: {
						id: id
					}
				})
			},
			// 移除图片
			removeFile(e) {
				this.fileList = []
				this.groupForm.avatarUri = ''
			},
			removeFile1(e) {
				this.fileList1 = []
				this.groupForm.indexPageUrl = ''
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				return rowIndex % 2 === 0 ? 'row-dark' : ''
			},
			selectAll() {
				let loading = this.$loading()
				this.$post('Groups/selectall', {
						'name': this.name,
						'pageNo': this.pageNo,
						'pageSize': this.pageSize
					})
					.then(res => {
						this.tableData = res.list.rows
						this.pageCount = res.list.pages
						for (var i = 0; i < res.list.rows.length; i++) {
							this.imageUriList.push(res.list.rows[i].imageUri)
							if (res.list.rows[i].indexPageUrl) {
								this.imageUriList1.push(res.list.rows[i].indexPageUrl)
							} else {
								this.imageUriList1.push('https://yunnanyihe.oss-cn-heyuan.aliyuncs.com/2025/02/26/4e4a60fb-7e19-41d7-b09c-744fbb708d80.png')
							}
						}
						loading.close()
					}, err => {
						this.$message.error(err)
						loading.close()
					})
			},
			addGroups() {
				this.addOrEdit = 0
				this.groupsVisible = true
				this.groupForm = {
					editPreInfoIsUseApprove: '0',
				}

				this.fileList = []
				this.fileList1 = []
			},
			editGroups(row) {
				console.log(row)
				this.addOrEdit = 1
				this.fileList = []
				this.fileList1 = []
				this.groupsVisible = true
				this.groupForm.id = row.id
				this.groupForm.name = row.name
				this.groupForm.avatarUri = row.imageUri
				this.groupForm.indexPageUrl = row.indexPageUrl
				this.groupForm.editPreInfoIsUseApprove = row.editPreInfoIsUseApprove.toString()
				this.fileList.push({
					name: '',
					url: row.imageUri
				})
				let logoUrl = ''
				logoUrl = row.indexPageUrl ? row.indexPageUrl : 'https://yunnanyihe.oss-cn-heyuan.aliyuncs.com/2025/02/26/4e4a60fb-7e19-41d7-b09c-744fbb708d80.png'
				this.fileList1.push({
					name: '',
					url: logoUrl
				})
			},
			delGroups(row) {
				let loading = this.$loading()
				this.$confirm(this.$i18n.t('lang.lab_deleteGroupRemind'), this.$i18n.t('lang.lab_prompt'), {
					confirmButtonText: this.$i18n.t('lang.btn_confirm'),
					cancelButtonText: this.$i18n.t('lang.btn_cancel'),
					type: 'warning'
				}).then(() => {
					this.$postJson('Groups/del', {
						'id': row.id
					}).then(res => {
						this.$message({
							type: 'success',
							message: this.$i18n.t('lang.lab_del_success')
						})
						this.selectAll()
						loading.close()
					}, err => {
						this.$message.error(err)
						loading.close()
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: this.$i18n.t('lang.lab_del_can')
					})
					loading.close()
				})
			},
			save() {
				console.log(this.groupForm)
				this.$refs.groupForm.validate((valid) => {
					if (valid) {
						let loading = this.$loading()
						if (this.addOrEdit != 1) {
							this.$postJson(`Groups/add`, {
									'name': this.groupForm.name,
									'imageUri': this.groupForm.avatarUri,
									'indexPageUrl': this.groupForm.indexPageUrl,
									'editPreInfoIsUseApprove': this.groupForm.editPreInfoIsUseApprove
								})
								.then(res => {
									this.$message.success(this.$i18n.t('lang.lab_save_success'))
									this.selectAll()
									loading.close()
								}, err => {
									this.$message.error(err)
									loading.close()
								})
						} else {
							this.$postJson(`Groups/update`, {
									'id': this.groupForm.id,
									'name': this.groupForm.name,
									'imageUri': this.groupForm.avatarUri,
									'indexPageUrl': this.groupForm.indexPageUrl,
									'editPreInfoIsUseApprove': this.groupForm.editPreInfoIsUseApprove
								})
								.then(res => {
									this.$message.success(this.$i18n.t('lang.lab_save_success'))
									this.selectAll()
									loading.close()
								}, err => {
									this.$message.error(err)
									loading.close()
								})
						}
						this.groupsVisible = false
					}
				})
			},

			getGardenList(id) {
				this.$get('/gardens')
					.then(res => {
						this.gardenList = res.list
						for (var i = 0; i < this.gardenList.length; i++) {
							this.gardenList[i].isDisable = false
						}
						this.getGardenListByGroup(id)
					}, err => {
						this.$message.error(err)
					})
			},
			getGardenListByGroup(id) {
				this.$postJson(`GroupsGarden/select`, {
						'groupId': id
					})
					.then(res => {
						let arr1 = res.list // 当前集团所选小区
						let arr2 = res.allList // 所有集团下的小区
						// 差集
						var diffSet = arr1.concat(arr2).filter(function (v) {
							return arr1.indexOf(v) === -1 || arr2.indexOf(v) === -1
						})
						for (var i = 0; i < this.gardenList.length; i++) {
							for (var j = 0; j < diffSet.length; j++) {
								if (this.gardenList[i].id === diffSet[j]) {
									this.gardenList[i].isDisable = true
								}
							}
						}
						this.gardenForm.gardenArr = res.list
					}, err => {
						this.$message.error(err)
					})
			},
			openGardenDialog(row) {
				this.gardenVisible = true
				this.groupId = row.id
				this.getGardenList(row.id)
			},
			saveGarden() {
				let loading = this.$loading()
				this.$postJson(`GroupsGarden/add`, {
					'groupId': this.groupId,
					'gardenIds': this.gardenForm.gardenArr
				}).then(res => {
					// console.log(res);
					this.$message.success(this.$i18n.t('lang.lab_save_success'))
					this.selectAll()
					loading.close()
					this.gardenVisible = false
				}, err => {
					this.$message.error(err)
					loading.close()
					this.gardenVisible = false
				})
			},
			// ID序号功能
			indexMethod(index) {
			    return (this.pageNo - 1) * this.pageSize + index + 1
			},
			// 翻页
			handleCurrentChange(val) {
			    this.pageNo = val
			    this.selectAll()
			},
			// 切换每页显示多少数据
			handleSizeChange(val) {
			    this.pageNo = 1
			    this.pageSize = val
			    this.selectAll()
			}
		}
	}
</script>

<style lang="scss">
	.groupsManage .el-checkbox-group{
		display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
	}
	.groupsManage .el-checkbox{
		width: 27%;
	}
	
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
	.tips{
		font-size: 12px;
		color: #F56C6C;
	}
</style>
